import { render, staticRenderFns } from "./LogoutUsuarioDesabilitado.vue?vue&type=template&id=c003d318&"
import script from "./LogoutUsuarioDesabilitado.vue?vue&type=script&lang=js&"
export * from "./LogoutUsuarioDesabilitado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports